import React from 'react';
import {ButtonBase} from '../../../elements';
import StepPopover from '../StepPopover/StepPopover';
import {useTranslation} from 'react-i18next';
import {useDispatch, useSelector} from "react-redux";
import {couponType, SET_RATE_COUPON, SET_RATE_COUPON_EVENT} from "../../../../store/spirs/actions";
import {CouponEvent} from "../../../../store/spirs/reducers/couponReducer";
import {StoreType} from "../../../../store/spirs/types";

interface StepsComputeProps {
    selectionId?: number,
    rate: number,
}

export const getMinOrMaxLimit = (couponType: couponType,
                          key: 'minRate' | 'maxRate',
                          events: CouponEvent[],
                          math: (...arr: number[]) => number,
                          selectionId?: number): number | null => {
    if (couponType === 'ORDINAR') {
        if (!selectionId) return null;
        const event = events.find(coupon => coupon.selectionId === selectionId);
        return event ? (event[key] || null) : null;
    }
    const values = events.map(event => event[key]).filter(v => v) as number[];
    return values.length > 0 ? math(...values) : null;

};



function StepsCompute(props: StepsComputeProps) {
    const dispatch = useDispatch();
    const {t} = useTranslation();
    const currentCouponType = useSelector((state: StoreType) => state.spirs.coupons.currentCouponType);
    const currentCouponEvents = useSelector((state: StoreType) => state.spirs.coupons[currentCouponType]);

    const getMinLimit = (): number | null => getMinOrMaxLimit(currentCouponType, "minRate", currentCouponEvents, Math.max, props.selectionId);
    const getMaxLimit = (): number | null => getMinOrMaxLimit(currentCouponType, "maxRate", currentCouponEvents, Math.min, props.selectionId);

    const maxLimit: number | null = getMaxLimit();
    const minLimit: number | null = getMinLimit();



    function setMaxStepValue() {
        if (!maxLimit) return;
        if (props.selectionId) {
            dispatch(SET_RATE_COUPON_EVENT(props.selectionId, maxLimit));
        } else {
            dispatch(SET_RATE_COUPON(maxLimit));
        }
    }

    // function setMinStepValue() {
    //     if (!minLimit) return;
    //     if (props.selectionId) {
    //         dispatch(SET_RATE_COUPON_EVENT(props.selectionId, minLimit));
    //     } else {
    //         dispatch(SET_RATE_COUPON(minLimit));
    //     }
    // }

    return (
        <div className="flex justify-between items-center flex-nowrap py-[13px] px-2.5 desktop:px-[16px] text-[12px] desktop:text-[16px] font-['Roboto'] leading-[100%]">
            <div className="flex">
                <ButtonBase onClick={setMaxStepValue} className="rounded-[8px] text-[#ABABAB]">
                    {t('coupons.maxStep')}: {maxLimit ? maxLimit : '-'}
                </ButtonBase>
            </div>

            {/* 
            <div className="flex">
                <ButtonBase onClick={setMinStepValue} className="p-[2px] rounded-[8px] text-[#ABABAB]">
                    {t('coupons.minStep')}: {minLimit ? minLimit : '-'}
                </ButtonBase>
            </div>
             */}


            <div className="flex">
                <StepPopover maxStepValue={maxLimit}
                             stepValue={props.rate.toString()}
                             minStepValue={minLimit}
                             selectionId={props.selectionId}
                />
            </div>
        </div>
    );
}

export default StepsCompute;
